import React from 'react';

import { useBrand } from '../../_libs/hooks/useBrand';
import DataOneLiner from './DataOneLiner';

export interface DataBarGraphType {
  label: string;
  percent: number | string;
  value?: number;
  risk?: LabelEnum; // TODO: Include risk label in aggregated data
}

const DataBarGraph:React.FC<DataBarGraphType> = ({ label, percent, value = null }) => {
  const { getColors } = useBrand();
  const colors = getColors();
  const bgColor = colors.light;
  const barColor = colors.primary;
  
  return (
    <div className="graph-container">
      <DataOneLiner
        label={label}
        value={(value != null) ? value.toFixed(0) : (parseFloat(`${percent}`).toFixed(2) + '%')}
      />
      <div className="graph-background bg-black relative" style={{
        backgroundColor: bgColor,
      }}>
        <div className="graph-foreground bg-white absolute" 
          style={{
            width: `${percent}%`,
            backgroundColor: barColor,
          }}></div>
      </div>
    </div>
  );
};

export default DataBarGraph;
